import Model, { attr } from '@ember-data/model';

export default class ContactDuplicateModel extends Model {
  @attr('boolean')
  declare rejected: boolean;

  @attr()
  declare contactIds: Array<string>;

  get firstContactId() {
    return this.contactIds[0];
  }

  get secondContactId() {
    return this.contactIds[1];
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'contact-duplicate': ContactDuplicateModel;
  }
}
